import React from "react";
import {clsx} from "clsx";

const BackgroundImage = ({src, srcMobile, alt}) => {
    return (
        <div className={clsx("absolute inset-0 z-0")}>
            <picture className="w-full h-full">
                <source media="(min-width: 768px)" srcSet={src}/>
                <img className="w-full h-full object-cover" src={srcMobile} alt={alt}/>
            </picture>
            <div className="absolute inset-0 bg-black/30"></div>
        </div>
    );
};

export default BackgroundImage;
